<my-widget-config
        [widgetComponent]="this"
        addTitle="{{'Create new notepad' | translate}}"
        editTitle="{{'Notepads' | translate}}"
>
    <ng-template #widgetParamsTemplate let-widget="widget">
        <my-field
                label="{{'Pad name' | translate}}"
                [placeholder]="defaultName"
                [(value)]="widget.dimension.newName"
                [disabled]="isUpdating"
                [maxlength]="39"
        ></my-field>
        <my-field
                label="{{'Pad URL' | translate}}"
                placeholder="https://scalar.vector.im/etherpad/p/MyCoolPadName"
                [(value)]="widget.dimension.newUrl"
                [disabled]="isUpdating"
        ></my-field>
    </ng-template>
</my-widget-config>
